import axios from "axios";

// Get all rate logs with pagination, search, and filters
export const getRateLogs = async ({
  page = 1,
  limit = 20,
  search = "",
  customer_id = "",
  start_date = "",
  end_date = "",
  status = ""
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);
    if (search) params.append("search", search);
    if (customer_id) params.append("customer_id", customer_id);
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    if (status) params.append("status", status);

    const { data } = await axios.get(`get-single-rate/logs?${params.toString()}`);
    return data;
  } catch (error) {
    console.error("Error fetching rate logs:", error);
    throw error;
  }
};

// Get single rate log by ID
export const getRateLogById = async (id) => {
  try {
    const { data } = await axios.get(`get-single-rate/logs/${id}`);
    return data;
  } catch (error) {
    console.error("Error fetching rate log:", error);
    throw error;
  }
};

// Delete rate log
export const deleteRateLog = async (id) => {
  try {
    const { data } = await axios.delete(`get-single-rate/logs/${id}`);
    return data;
  } catch (error) {
    console.error("Error deleting rate log:", error);
    throw error;
  }
};
